module.exports = __webpack_public_path__ + "img/waiting-omni.eef7bb51.png";